import React, { memo } from "react";
import { Modal } from "react-bootstrap";
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import AppMessage from "../Constant/AppMessage";

type Props = {
  showConfirmModal: boolean;
  onPressConfirm: () => void;
  onPressClose: () => void;
};

const ConfirmModal = (props: Props) => {
  return (
    <Modal show={props.showConfirmModal} centered className="errorModal">
      <Modal.Body>
        <div className="error_modal_content">
          <div className="check-icon">
            <FontAwesomeIcon
              icon={faCircleXmark as IconProp}
              className="uncheck_circle"
            />
          </div>
          <div className="error_text_content">
            {AppMessage.callEndConfirmation}
          </div>
          <div className="error_end_btn">
            <button onClick={props.onPressClose} className="v_button">
              Close
            </button>
            <button
              style={{ marginLeft: "10px" }}
              onClick={props.onPressConfirm}
              className="v_button"
            >
              End Call
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default  memo(ConfirmModal);
